import yup from "yup";
import locale from "@bonliva-crm/locale";
import { CardType } from "@bonliva-crm/shared";
import { CommonFormData } from "../../quality-item-editor";

type CardTypeOption = {
  label: string;
  value: string;
};

export type FormData = CommonFormData & {
  cardType?: CardTypeOption;
  cardNumber?: string;
  sendEmail?: boolean;
};

export const cardTypeOptions = Object.values(CardType).toLabelValue(
  (v) => locale.cardTypes[v]
);

export const schema = yup.object<FormData>({
  date: yup.date(),
  cardType: yup
    .object<CardTypeOption>()
    .nullable(true)
    .required(locale.required(locale.CartType)),
  cardNumber: yup.string().nullable(true),
  comment: yup.string().nullable(true),
  sendEmail: yup.boolean()
});
